type GTMEvent = {
  event: string;
  [key: string]: any;
};

export const pushGTMEvent = (data: GTMEvent) => {
  if (typeof window !== 'undefined') {
    const w = window as Window & { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push(data);
  }
};
